"use client";

import { c as _c } from "react/compiler-runtime";
import type { IProfileConsolidation } from "@/entities/IProfile";
import { numberWithCommas, parseEmojis } from "@/helpers/Helpers";
import { faArrowsTurnRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import styles from "./Address.module.scss";
import { WalletAddress } from "./WalletAddress";
interface Props {
  wallets: `0x${string}`[];
  consolidatedWallets?: IProfileConsolidation[] | undefined;
  display: string | undefined;
  displayEns?: string | undefined;
  hideCopy?: boolean | undefined;
  tags?: {
    memesCardsSets: number;
    memesCardsSetS1: number;
    memesCardsSetS2: number;
    memesCardsSetS3: number;
    memesCardsSetS4: number;
    memesCardsSetS5: number;
    memesCardsSetS6: number;
    memesBalance: number;
    genesis: number;
    gradientsBalance: number;
    tdh_rank?: number | undefined;
    balance_rank?: number | undefined;
    unique_rank?: number | undefined;
  } | undefined;
  isUserPage?: boolean | undefined;
  disableLink?: boolean | undefined;
  viewingWallet?: `0x${string}` | undefined;
  expandedTags?: boolean | undefined;
  setLinkQueryAddress?: boolean | undefined;
}
const MEMES_SETS_ICON = "";
const UNIQUE_MEMES_ICON = "";
const SZN_1_ICON = "";
const SZN_2_ICON = "";
const SZN_3_ICON = "";
const SZN_4_ICON = "";
const SZN_5_ICON = "";
const SZN_6_ICON = "";
const GRADIENT_ICON = "";
export default function Address(props) {
  const $ = _c(35);
  const [consolidationExpanded, setConsolidationExpanded] = useState(!!props.isUserPage);
  let t0;
  if ($[0] !== props.consolidatedWallets || $[1] !== props.display) {
    t0 = (wallet, index) => {
      const walletObj = props.consolidatedWallets?.find(c => c.wallet.address.toLowerCase() === wallet.toLowerCase());
      if (walletObj) {
        return {
          display: walletObj.wallet.ens,
          displayEns: walletObj.wallet.ens
        };
      }
      const ens = props.display?.split(" - ")[index]?.endsWith(".eth") ? props.display?.split(" - ")[index] : undefined;
      return {
        display: ens ?? wallet,
        displayEns: ens
      };
    };
    $[0] = props.consolidatedWallets;
    $[1] = props.display;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getWalletDisplayAndEns = t0;
  let t1;
  if ($[3] !== props.display || $[4] !== props.wallets[0]) {
    t1 = function getProfileLink() {
      if (props.display && !props.display.includes(" ")) {
        return `/${props.display}`;
      }
      return `/${props.wallets[0]}`;
    };
    $[3] = props.display;
    $[4] = props.wallets[0];
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const getProfileLink = t1;
  let t2;
  if ($[6] !== consolidationExpanded || $[7] !== getProfileLink || $[8] !== props.disableLink || $[9] !== props.display || $[10] !== props.displayEns || $[11] !== props.hideCopy || $[12] !== props.isUserPage || $[13] !== props.setLinkQueryAddress || $[14] !== props.wallets[0] || $[15] !== props.wallets.length) {
    t2 = props.wallets.length === 1 ? <WalletAddress wallet={props.wallets[0]} display={props.display} displayEns={props.displayEns} hideCopy={props.hideCopy} disableLink={props.disableLink} isUserPage={props.isUserPage} setLinkQueryAddress={props.setLinkQueryAddress} /> : <Dropdown className={`${styles.consolidationDropdown}`} autoClose="outside"><Dropdown.Toggle name="consolidation-toggle" aria-label="consolidation-toggle"><Image unoptimized={true} loading="eager" priority={true} src="/consolidation-icon.png" alt="consolidation" width={25} height={25} style={{
          transition: "transform 0.2s ease",
          transform: consolidationExpanded ? "rotate(90deg)" : "rotate(0deg)"
        }} onClick={() => {
          if (!props.isUserPage) {
            setConsolidationExpanded(!consolidationExpanded);
          }
        }} />  <Link className="decoration-none decoration-hover-underline" href={getProfileLink()}><span className={`${styles.consolidationDisplay} ${props.isUserPage ? styles.consolidationDisplayUserPage : ""}`} dangerouslySetInnerHTML={{
            __html: props.display ? parseEmojis(props.display) : ""
          }} /></Link></Dropdown.Toggle></Dropdown>;
    $[6] = consolidationExpanded;
    $[7] = getProfileLink;
    $[8] = props.disableLink;
    $[9] = props.display;
    $[10] = props.displayEns;
    $[11] = props.hideCopy;
    $[12] = props.isUserPage;
    $[13] = props.setLinkQueryAddress;
    $[14] = props.wallets[0];
    $[15] = props.wallets.length;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  const t3 = props.isUserPage ? "d-flex flex-wrap align-items-center gap-2" : "d-flex flex-column";
  let t4;
  if ($[17] !== consolidationExpanded || $[18] !== getWalletDisplayAndEns || $[19] !== props.hideCopy || $[20] !== props.isUserPage || $[21] !== props.setLinkQueryAddress || $[22] !== props.wallets) {
    t4 = (consolidationExpanded || props.isUserPage) && props.wallets.length > 1 && props.wallets.map((w, index_0) => <div key={w} className={`d-flex align-items-center justify-content-start ${props.isUserPage ? styles.consolidationDiv : ""}`}><FontAwesomeIcon icon={faArrowsTurnRight} name="arrow-turn-right" aria-label="arrow-turn-right" className={`${styles.arrowTurnRight}`} /><WalletAddress wallet={w} display={getWalletDisplayAndEns(w, index_0).display} displayEns={getWalletDisplayAndEns(w, index_0).displayEns} hideCopy={props.hideCopy} disableLink={false} setLinkQueryAddress={props.setLinkQueryAddress} /></div>);
    $[17] = consolidationExpanded;
    $[18] = getWalletDisplayAndEns;
    $[19] = props.hideCopy;
    $[20] = props.isUserPage;
    $[21] = props.setLinkQueryAddress;
    $[22] = props.wallets;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== t3 || $[25] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== props.expandedTags || $[28] !== props.isUserPage || $[29] !== props.tags) {
    t6 = props.tags && <span className={styles.noWrap}>{(props.tags.tdh_rank || props.tags.balance_rank) && <>{props.tags.balance_rank && props.tags.balance_rank > 0 && props.expandedTags && <span className={`${styles.addressTag} ${styles.rankTag}`}>All Cards Rank #{numberWithCommas(props.tags.balance_rank)}</span>}{props.tags.unique_rank && props.tags.unique_rank > 0 && props.expandedTags && <span className={`${styles.addressTag} ${styles.rankTag}`}>Unique Cards Rank #{numberWithCommas(props.tags.unique_rank)}</span>}{props.tags.tdh_rank && props.tags.tdh_rank > 0 && props.expandedTags && <span className={`${styles.addressTag} ${styles.rankTag}`}>TDH Rank #{numberWithCommas(props.tags.tdh_rank)}</span>}<br /></>}{props.tags.memesCardsSets > 0 ? <span className={`${styles.addressTag} ${!MEMES_SETS_ICON ? styles.memesSetTag : ""}`}>{(props.isUserPage || !MEMES_SETS_ICON) && "Memes Sets x"}{props.tags.memesCardsSets}{MEMES_SETS_ICON && <img src={MEMES_SETS_ICON} className={styles.addressTagIcon} alt="Memes Sets" />}</span> : props.tags.memesBalance > 0 ? <span className={`${styles.addressTag} ${!UNIQUE_MEMES_ICON ? styles.memesTag : ""}`}>{(props.isUserPage || !UNIQUE_MEMES_ICON) && "Memes x"}{props.tags.memesBalance}{props.tags.genesis > 0 ? " (+Genesis) " : ""}{UNIQUE_MEMES_ICON && <img src={UNIQUE_MEMES_ICON} className={styles.addressTagIcon} alt="Unique Memes" />}</span> : ""}{props.tags.gradientsBalance > 0 && !props.expandedTags ? <span className={`${styles.addressTag} ${!GRADIENT_ICON ? styles.gradientTag : ""}`}>{(props.isUserPage || !GRADIENT_ICON) && "Gradients x"}{props.tags.gradientsBalance}{GRADIENT_ICON && <img src={GRADIENT_ICON} className={styles.addressTagIcon} alt="6529 Gradient" />}</span> : <>{props.tags.memesCardsSetS1 > 0 && (props.tags.memesCardsSets === 0 || props.expandedTags) && <span className={`${styles.addressTag} ${!SZN_1_ICON ? styles.memeSzn1Tag : ""}`}>{(props.isUserPage || !SZN_1_ICON) && "SZN1 Sets x"}{props.tags.memesCardsSetS1}{SZN_1_ICON && <img src={SZN_1_ICON} className={styles.addressTagIcon} alt="Memes SZN1" />}</span>}{props.tags.memesCardsSetS2 > 0 && (props.tags.memesCardsSets === 0 || props.expandedTags) && <span className={`${styles.addressTag} ${!SZN_2_ICON ? styles.memeSzn2Tag : ""}`}>{(props.isUserPage || !SZN_2_ICON) && "SZN2 Sets x"}{props.tags.memesCardsSetS2}{SZN_2_ICON && <img src={SZN_2_ICON} className={styles.addressTagIcon} alt="Memes SZN2" />}</span>}{props.tags.memesCardsSetS3 > 0 && (props.tags.memesCardsSets === 0 || props.expandedTags) && <span className={`${styles.addressTag} ${!SZN_3_ICON ? styles.memeSzn3Tag : ""}`}>{(props.isUserPage || !SZN_3_ICON) && "SZN3 Sets x"}{props.tags.memesCardsSetS3}{SZN_3_ICON && <img src={SZN_3_ICON} className={styles.addressTagIcon} alt="Memes SZN3" />}</span>}{props.tags.memesCardsSetS4 > 0 && (props.tags.memesCardsSets === 0 || props.expandedTags) && <span className={`${styles.addressTag} ${!SZN_4_ICON ? styles.memeSzn4Tag : ""}`}>{(props.isUserPage || !SZN_4_ICON) && "SZN4 Sets x"}{props.tags.memesCardsSetS4}{SZN_4_ICON && <img src={SZN_4_ICON} className={styles.addressTagIcon} alt="Memes SZN4" />}</span>}{props.tags.memesCardsSetS5 > 0 && (props.tags.memesCardsSets === 0 || props.expandedTags) && <span className={`${styles.addressTag} ${!SZN_5_ICON ? styles.memeSzn5Tag : ""}`}>{(props.isUserPage || !SZN_5_ICON) && "SZN5 Sets x"}{props.tags.memesCardsSetS5}{SZN_5_ICON && <img src={SZN_5_ICON} className={styles.addressTagIcon} alt="Memes SZN5" />}</span>}{props.tags.memesCardsSetS6 > 0 && (props.tags.memesCardsSets === 0 || props.expandedTags) && <span className={`${styles.addressTag} ${!SZN_6_ICON ? styles.memeSzn6Tag : ""}`}>{(props.isUserPage || !SZN_6_ICON) && "SZN6 Sets x"}{props.tags.memesCardsSetS6}{SZN_6_ICON && <img src={SZN_6_ICON} className={styles.addressTagIcon} alt="Memes SZN6" />}</span>}{props.tags.gradientsBalance > 0 && props.expandedTags && <span className={`${styles.addressTag} ${!GRADIENT_ICON ? styles.gradientTag : ""}`}>{(props.isUserPage || !GRADIENT_ICON) && "Gradients x"}{props.tags.gradientsBalance}{GRADIENT_ICON && <img src={GRADIENT_ICON} className={styles.addressTagIcon} alt="6529 Gradient" />}</span>}</>}</span>;
    $[27] = props.expandedTags;
    $[28] = props.isUserPage;
    $[29] = props.tags;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== t2 || $[32] !== t5 || $[33] !== t6) {
    t7 = <>{t2}{t5}{t6}</>;
    $[31] = t2;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  return t7;
}